import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConciliarContaListarComponent } from './conciliar-conta-listar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:'', component: ConciliarContaListarComponent}
  ])],
  exports: [RouterModule]
})
export class ConciliarContaListarRoutingModule { }
